import { FC } from 'react';

interface NotificationSkeletonProps {
  count?: number;
}

const NotificationSkeleton: FC<NotificationSkeletonProps> = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          className="flex mt-2 first:mt-0 items-start p-3 animate-pulse">
          <div className="mr-3 flex-shrink-0">
            <div className="bg-gray-200 w-8 h-8 rounded" />
          </div>
          <div className="flex-1 flex flex-col gap-6">
            <div className="bg-gray-200 h-4 w-3/4 rounded mb-2" />
            <div className="flex justify-between items-center">
              <div className="bg-gray-200 h-3 w-16 rounded" />
              <div className="bg-gray-200 h-3 w-12 rounded" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default NotificationSkeleton;
